<template>
    <div class="Page">
        <Header :Act="headerAct"></Header>
        <div class="MaxWid">
            <div class="MarTop">
                <div class="AboutPos" @click="back">当前位置：{{ breadcrumbText }}</div>
            </div>
            <div class="Cont" v-if="detail">
                <div class="title">{{ detail.title || detail.name }}</div>
                <div class="ContDis">
                    <div class="Flex">授课类型：{{ getProjectTypeText(detail.project_type) }}</div>
                    <div class="Flex">状态：{{ detail.status_text || '-' }}</div>
                </div>
                <div class="project-section">
                    <div class="section-title">基础信息</div>
                    <div class="info-grid">
                        <div class="info-item">
                            <div class="label">机构名称</div>
                            <div class="value">{{ detail.company_name || '-' }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">项目类型</div>
                            <div class="value">{{ getCourseCategoryText(detail.course_category) }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">授课类型</div>
                            <div class="value">{{ getProjectTypeText(detail.project_type) }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">开始时间</div>
                            <div class="value">{{ detail.start_date || '-' }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">结束时间</div>
                            <div class="value">{{ detail.end_date || '-' }}</div>
                        </div>
                        <div class="info-item">
                            <div class="label">收费标准</div>
                            <div class="value">{{ detail.fee ? detail.fee + ' 元/人' : '-' }}</div>
                        </div>
                    </div>
                    <div class="info-block" v-if="detail.project_application">
                        <div class="label">项目申请表</div>
                        <div class="value file-link" @click="OpenLock(detail.project_application)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.training_program">
                        <div class="label">培训方案与学员管理制度</div>
                        <div class="value file-link" @click="OpenLock(detail.training_program)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.assessment_plan">
                        <div class="label">考核评价方案及结业标准</div>
                        <div class="value file-link" @click="OpenLock(detail.assessment_plan)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.cost_structure">
                        <div class="label">成本构成说明</div>
                        <div class="value file-link" @click="OpenLock(detail.cost_structure)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.refund_policy">
                        <div class="label">退费机制说明</div>
                        <div class="value file-link" @click="OpenLock(detail.refund_policy)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.emergency_plan">
                        <div class="label">应急预案与风险管控方案</div>
                        <div class="value file-link" @click="OpenLock(detail.emergency_plan)">查看PDF</div>
                    </div>
                    <div class="info-block" v-if="detail.last_experience">
                        <div class="label">过往项目经验及学员反馈材料</div>
                        <div class="value file-link" @click="OpenLock(detail.last_experience)">查看PDF</div>
                    </div>
                </div>

                <div class="project-section" v-if="Array.isArray(detail.course) && detail.course.length">
                    <div class="section-title">课程信息</div>
                    <el-table :data="detail.course" border style="width: 100%">
                        <el-table-column prop="course_module" label="课程模块" width="180"></el-table-column>
                        <el-table-column prop="teaching_objective" label="教学目标" width="180"></el-table-column>
                        <el-table-column prop="content" label="课程内容" width="200"></el-table-column>
                        <el-table-column prop="teacher" label="讲师" width="120"></el-table-column>
                        <el-table-column prop="hours" label="课时" width="120"></el-table-column>
                        <el-table-column prop="remark" label="备注"></el-table-column>
                    </el-table>
                </div>

                <div class="project-section" v-if="Array.isArray(detail.teachers) && detail.teachers.length">
                    <div class="section-title">师资信息</div>
                    <el-table :data="detail.teachers" border style="width: 100%">
                        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                        <el-table-column prop="company" label="所属单位" width="180"></el-table-column>
                        <el-table-column prop="specialty" label="专业领域" width="180"></el-table-column>
                        <el-table-column label="资质证明" width="120">
                            <template slot-scope="scope">
                                <span v-if="scope.row.qualification_cert" class="file-link" @click="OpenLock(scope.row.qualification_cert)">查看PDF</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="授课协议" width="120">
                            <template slot-scope="scope">
                                <span v-if="scope.row.teaching_agreement" class="file-link" @click="OpenLock(scope.row.teaching_agreement)">查看PDF</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="project-section" v-if="Array.isArray(detail.team) && detail.team.length">
                    <div class="section-title">项目管理团队</div>
                    <el-table :data="detail.team" border style="width: 100%">
                        <el-table-column prop="name" label="姓名" width="120"></el-table-column>
                        <el-table-column prop="education_background" label="教育背景" width="180"></el-table-column>
                        <el-table-column label="劳动合同/社保证明" width="160">
                            <template slot-scope="scope">
                                <span v-if="scope.row.labor_contract" class="file-link" @click="OpenLock(scope.row.labor_contract)">查看PDF</span>
                                <span v-else>-</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="other" label="其他"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div class="Empty" v-else>
                暂无项目信息，请从列表重新进入。
            </div>
        </div>
        <Footer></Footer>
    </div>
</template>

<script>
import Header from '@/components/header/head';
import Footer from '@/components/header/footer';

export default {
    components: { Header, Footer },
    data() {
        return {
            detail: null,
            source: 'education',
            headerAct: 5,
        }
    },
    computed: {
        breadcrumbText() {
            return this.source === 'user' ? '个人中心 / 项目申请' : '继续教育';
        }
    },
    mounted() {
        const cache = localStorage.getItem("ProjectDetailData");
        if (cache) {
            try {
                this.detail = JSON.parse(cache);
            } catch (e) {
                console.error("解析缓存的项目详情失败", e);
            }
        }
        const source = localStorage.getItem("ProjectDetailSource");
        if (source) {
            this.source = source;
        }
        this.headerAct = this.source === 'user' ? 99 : 5;

        const id = this.detail && this.detail.id;
        // 不再依赖路由参数，使用缓存中的 id，从列表接口获取完整数据
        this.tryFetchDetail(id);
    },
    methods: {
        back() {
            this.$router.go(-1);
        },
        OpenLock(res) {
            if (!res) return;
            this.$Global.previewFile(res);
        },
        getProjectTypeText(type) {
            const map = {
                '1': '线上',
                '2': '线下',
                '3': '线上线下结合',
            };
            return map[String(type)] || '未知';
        },
        getCourseCategoryText(type) {
            const map = {
                '1': '专业基础课程',
                '2': '专业进阶课程',
                '3': '专业专题课程',
            };
            return map[String(type)] || '未知';
        },
        async tryFetchDetail(id) {
            try {
                // 使用个人中心同一接口获取全量列表，再匹配当前ID
                const res = await this.$post("api/user/projectList", { page: 1, limit: 1000 });
                if (res.data && res.data.code === 1) {
                    const payload = res.data.data;
                    const list =
                        Array.isArray(payload) ? payload :
                        (payload && Array.isArray(payload.data) ? payload.data : []);
                    const detail = list.find(item => String(item.id) === String(id)) || list[0];
                    this.detail = detail || null;
                    if (this.detail) {
                        localStorage.setItem("ProjectDetailData", JSON.stringify(this.detail));
                    }
                }
            } catch (error) {
                console.error("获取项目详情失败", error);
            }
        }
    }
}
</script>

<style scoped>
    .Page {
        background: #fff;
    }
    .MarTop {
        margin-top: 20px;
    }
    .MaxWid {
        max-width: 1180px;
        padding: 0 10px;
        margin: 0 auto;
    }
    .AboutPos{
        padding: 20px 0;
        font-size: 12px;
        color: #999999;
        cursor: pointer;
    }
    .title{
        padding: 20px 0;
        text-align: center;
        font-size: 18px;
    }
    .ContDis{
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }
    .ContDis .Flex{
        width: 30%;
        font-size: 14px;
        color: #666;
        padding-bottom:20px;
        text-align: center;
    }
    .ContHead{
        margin: 20px 0;
        width: 100%;
    }
    .project-section{
        margin-top: 20px;
        background: #f8f9fa;
        padding: 20px;
        border-radius: 6px;
    }
    .section-title{
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 15px;
        padding-left: 10px;
        border-left: 4px solid #409EFF;
    }
    .info-grid{
        display: grid;
        grid-template-columns: repeat(auto-fit,minmax(200px,1fr));
        gap: 12px;
    }
    .info-item{
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        padding: 12px;
    }
    .info-item .label{
        color: #666;
        margin-bottom: 6px;
        font-size: 14px;
    }
    .info-item .value{
        color: #333;
        word-break: break-all;
    }
    .info-block{
        margin-top: 16px;
        background: #fff;
        border: 1px solid #e6e6e6;
        border-radius: 4px;
        padding: 12px;
    }
    .info-block .label{
        color: #666;
        margin-bottom: 6px;
        font-size: 14px;
    }
    .info-block .value{
        color: #333;
        word-break: break-all;
    }
    .file-link{
        color: #409EFF;
        cursor: pointer;
    }
    .experience-files{
        display: flex;
        flex-wrap: wrap;
        gap: 15px;
    }
    .experience-file .LockImg{
        width: 120px;
        height: 120px;
        object-fit: cover;
        border-radius: 4px;
        border: 1px solid #EBEEF5;
        cursor: pointer;
    }
    .Empty{
        padding: 60px 20px;
        text-align: center;
        color: #666;
    }
</style>

